export function avatarSidToUrl(
  avatarSid: string | undefined | null,
  thumbnail?: boolean
): string | undefined {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT
  if (avatarSid === 'rentana_ai') {
    return getRentanaAiAvatarUrl(thumbnail)
  }
  const baseUrl = `https://rentana-avatar${env === 'dev' ? '-dev' : ''}.s3.us-west-2.amazonaws.com/`
  return avatarSid ? `${baseUrl}${avatarSid}${thumbnail ? '-thumbnail' : ''}` : undefined
}

function getRentanaAiAvatarUrl(thumbnail?: boolean): string {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT
  return `/${env === 'dev' ? 'dev' : 'prod'}/rentana-ai${thumbnail ? '-thumbnail' : ''}.png`
}
